'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _iconSend = require('../icons/icon-send');

var _iconSend2 = _interopRequireDefault(_iconSend);

var _themeable = require('../themeable');

var _themeable2 = _interopRequireDefault(_themeable);

var _mobileDetect = require('../internal/mobile-detect');

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/require-default-props: 0 */


var propTypes = {
  /**
   * Callback fired when MessageInput's value changes
   *
   * function(event: object) => void
   */
  onChange: _propTypes2.default.func.isRequired,
  /**
   * Callback fired when a message is sent
   *
   * function(event: object) => void
   */
  sendMessage: _propTypes2.default.func.isRequired,
  /** The input's value */
  value: _propTypes2.default.string.isRequired,
  /** The input's placeholder */
  placeholder: _propTypes2.default.node.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the input element */
  inputStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The input's max length */
  maxLength: _propTypes2.default.number,
  /** Left-hand side placed button */
  leftButton: _propTypes2.default.node,
  /** Right-hand side placed button */
  rightButton: _propTypes2.default.node,
  /** Ref function to the element */
  inputRef: _propTypes2.default.func,
  /** Disables the input for the messageInput area */
  disabled: _propTypes2.default.bool,
  /** Multi line input. If true, a textarea element will be rendered. */
  multiLine: _propTypes2.default.bool,
  /** Multi line input's max visible rows. */
  maxRows: _propTypes2.default.number,
  /** Multi line input's row height. */
  rowHeight: _propTypes2.default.number,
  /** Color for the send button icon */
  sendIconColor: _propTypes2.default.string,
  /** Custom send button icon */
  sendIcon: _propTypes2.default.node,
  /** Override the styles of the input's placeholder */
  placeholderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  inputStyle: {},
  placeholderStyle: {},
  maxLength: 500,
  leftButton: null,
  disabled: false,
  rightButton: null,
  inputRef: null,
  multiLine: false,
  maxRows: 12,
  sendIconColor: '',
  sendIcon: null,
  rowHeight: 16
};

var displayName = 'MessageInput';

/** Message input with send button */

var MessageInput = function (_Component) {
  _inherits(MessageInput, _Component);

  function MessageInput() {
    _classCallCheck(this, MessageInput);

    var _this = _possibleConstructorReturn(this, (MessageInput.__proto__ || Object.getPrototypeOf(MessageInput)).call(this));

    _this.setTextareaHeight = function () {
      var _this$props = _this.props,
          rowHeight = _this$props.rowHeight,
          maxRows = _this$props.maxRows;
      var height = _this.state.height;


      _this.textarea.style.height = '1px';

      if (_this.textarea.scrollHeight > 48) {
        _this.setState({
          multiLine: true
        });
      } else {
        _this.setState({
          multiLine: false
        });
      }

      if (_this.textarea.scrollHeight !== height && _this.textarea.scrollHeight < maxRows * rowHeight) {
        if (_this.textarea.scrollHeight < 49) {
          _this.setState({
            height: 48
          });
        } else {
          _this.setState({
            height: _this.textarea.scrollHeight
          });
        }
      }

      _this.textarea.scrollTop = _this.textarea.scrollHeight;
      _this.textarea.style.height = '100%';
    };

    _this.handleChange = function (event) {
      var onChange = _this.props.onChange;


      _this.setTextareaHeight();

      onChange(event);
    };

    _this.handleKeyDown = function (event) {
      var multiLine = _this.props.multiLine;


      if (_mobileDetect2.default.mobile() && multiLine) {
        return false;
      }

      if (event.which === 13 && !event.shiftKey) {
        return _this.handleMessageSend(event);
      }

      return false;
    };

    _this.handleMessageSend = function (event) {
      var _this$props2 = _this.props,
          multiLine = _this$props2.multiLine,
          sendMessage = _this$props2.sendMessage;
      var height = _this.state.height;


      if (multiLine && height > 48) {
        _this.setState({
          height: 48,
          multiLine: false
        });
      }

      if (multiLine) {
        event.preventDefault();
      }

      sendMessage(event);
    };

    _this.state = {
      height: 48,
      multiLine: false
    };
    return _this;
  }

  _createClass(MessageInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var multiLine = this.props.multiLine;


      if (multiLine && this.textarea) {
        this.setTextareaHeight();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          sendMessage = _props.sendMessage,
          placeholder = _props.placeholder,
          value = _props.value,
          maxLength = _props.maxLength,
          leftButton = _props.leftButton,
          inputRef = _props.inputRef,
          disabled = _props.disabled,
          style = _props.style,
          inputStyle = _props.inputStyle,
          color = _props.color,
          rightButton = _props.rightButton,
          multiLine = _props.multiLine,
          maxRows = _props.maxRows,
          sendIconColor = _props.sendIconColor,
          sendIcon = _props.sendIcon,
          placeholderStyle = _props.placeholderStyle,
          rowHeight = _props.rowHeight,
          custom = _objectWithoutProperties(_props, ['onChange', 'sendMessage', 'placeholder', 'value', 'maxLength', 'leftButton', 'inputRef', 'disabled', 'style', 'inputStyle', 'color', 'rightButton', 'multiLine', 'maxRows', 'sendIconColor', 'sendIcon', 'placeholderStyle', 'rowHeight']);

      var height = this.state.height;


      var input = _react2.default.createElement('input', _extends({
        style: _getStyles2.default.input(inputStyle),
        placeholder: placeholder,
        onChange: onChange,
        value: value,
        type: 'text',
        onKeyDown: this.handleKeyDown,
        maxLength: maxLength,
        ref: inputRef,
        disabled: disabled,
        key: 'input',
        className: 'message-input'
      }, custom));

      if (multiLine) {
        input = _react2.default.createElement('textarea', _extends({
          style: _getStyles2.default.textarea(inputStyle),
          placeholder: placeholder,
          onChange: this.handleChange,
          value: value,
          type: 'text',
          onKeyDown: this.handleKeyDown,
          maxLength: maxLength,
          rows: maxRows,
          ref: function ref(node) {
            _this2.textarea = node;

            if (inputRef) {
              inputRef(node);
            }
          },
          disabled: disabled,
          key: 'input',
          className: 'message-input'
        }, custom));
      }

      return _react2.default.createElement(
        'section',
        { style: _getStyles2.default.root(disabled, height, this.state.multiLine, style) },
        leftButton ? _react2.default.createElement(
          'div',
          { style: _styles2.default.buttons },
          leftButton
        ) : null,
        input,
        _react2.default.createElement(
          'div',
          { style: _styles2.default.buttons },
          rightButton,
          _react2.default.createElement(
            _button2.default,
            {
              iconButton: true,
              onClick: this.handleMessageSend
            },
            sendIcon || _react2.default.createElement(_iconSend2.default, { color: sendIconColor || color })
          )
        ),
        _react2.default.createElement(_radium.Style, {
          rules: {
            '.message-input::placeholder': _getStyles2.default.placeholder(placeholderStyle)
          }
        })
      );
    }
  }]);

  return MessageInput;
}(_react.Component);

MessageInput.propTypes = propTypes;
MessageInput.defaultProps = defaultProps;
MessageInput.displayName = displayName;

var enhance = (0, _compose2.default)((0, _themeable2.default)(), _radium2.default);

MessageInput.displayName = displayName;
MessageInput.propTypes = propTypes;
MessageInput.defaultProps = defaultProps;

exports.default = enhance(MessageInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message-input/index.js
// module id = 824
// module chunks = 0